import { render, staticRenderFns } from "./NsCvvForm.vue?vue&type=template&id=873a9836&scoped=true&"
import script from "./NsCvvForm.vue?vue&type=script&lang=js&"
export * from "./NsCvvForm.vue?vue&type=script&lang=js&"
import style0 from "./NsCvvForm.vue?vue&type=style&index=0&lang=scss&module=%24x&"
import style1 from "./NsCvvForm.vue?vue&type=style&index=1&id=873a9836&lang=scss&scoped=true&"
import style2 from "./NsCvvForm.vue?vue&type=style&index=2&lang=scss&"




function injectStyles (context) {
  
  this["$x"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "873a9836",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/gitlab-runner-data/builds/ns-am/product/apps/catalog/components/Button.vue').default})
